import { render, staticRenderFns } from "./seniority2.vue?vue&type=template&id=90fa3de2&scoped=true&"
import script from "./seniority2.vue?vue&type=script&lang=js&"
export * from "./seniority2.vue?vue&type=script&lang=js&"
import style0 from "./seniority2.vue?vue&type=style&index=0&id=90fa3de2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fa3de2",
  null
  
)

export default component.exports